(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', '../model/WidgetCreationResponse', '../model/WidgetTemplate', '../model/WidgetRegisterRequest', '../model/Nothing', '../model/GetWidgetResp', '../model/WidgetTemplateQueryResponse', '../model/WidgetGetUpdatesResponse', '../model/Widget', '../model/WidgetTemplateUpdateRequest'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/WidgetCreationResponse'), require('../model/WidgetTemplate'), require('../model/WidgetRegisterRequest'), require('../model/Nothing'), require('../model/GetWidgetResp'), require('../model/WidgetTemplateQueryResponse'), require('../model/WidgetGetUpdatesResponse'), require('../model/Widget'), require('../model/WidgetTemplateUpdateRequest'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.VwidgetsApi = factory(root.SmartCsV2Sdk.ApiClient, root.SmartCsV2Sdk.WidgetCreationResponse, root.SmartCsV2Sdk.WidgetTemplate, root.SmartCsV2Sdk.WidgetRegisterRequest, root.SmartCsV2Sdk.Nothing, root.SmartCsV2Sdk.GetWidgetResp, root.SmartCsV2Sdk.WidgetTemplateQueryResponse, root.SmartCsV2Sdk.WidgetGetUpdatesResponse, root.SmartCsV2Sdk.Widget, root.SmartCsV2Sdk.WidgetTemplateUpdateRequest);
  }
}(this, function(ApiClient, WidgetCreationResponse, WidgetTemplate, WidgetRegisterRequest, Nothing, GetWidgetResp, WidgetTemplateQueryResponse, WidgetGetUpdatesResponse, Widget, WidgetTemplateUpdateRequest) {
  'use strict';

  /**
   * Vwidgets service.
   * @module api/VwidgetsApi
   * @version 2.0.624
   */

  /**
   * Constructs a new VwidgetsApi. 
   * @alias module:api/VwidgetsApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use, default to {@link module:ApiClient#instance}
   * if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the addWidgetMetadata operation.
     * @callback module:api/VwidgetsApi~addWidgetMetadataCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WidgetCreationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a widget metadata
     * @param {String} widgetId 
     * @param {String} metadata 
     * @param {File} icon 
     * @param {File} placeholder 
     * @param {File} thumbnail 
     * @param {File} preview 
     * @param {module:api/VwidgetsApi~addWidgetMetadataCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/WidgetCreationResponse}
     */
    this.addWidgetMetadata = function(widgetId, metadata, icon, placeholder, thumbnail, preview, callback) {
      var postBody = null;

      // verify the required parameter 'widgetId' is set
      if (widgetId == undefined || widgetId == null) {
        throw "Missing the required parameter 'widgetId' when calling addWidgetMetadata";
      }

      // verify the required parameter 'metadata' is set
      if (metadata == undefined || metadata == null) {
        throw "Missing the required parameter 'metadata' when calling addWidgetMetadata";
      }

      // verify the required parameter 'icon' is set
      if (icon == undefined || icon == null) {
        throw "Missing the required parameter 'icon' when calling addWidgetMetadata";
      }

      // verify the required parameter 'placeholder' is set
      if (placeholder == undefined || placeholder == null) {
        throw "Missing the required parameter 'placeholder' when calling addWidgetMetadata";
      }

      // verify the required parameter 'thumbnail' is set
      if (thumbnail == undefined || thumbnail == null) {
        throw "Missing the required parameter 'thumbnail' when calling addWidgetMetadata";
      }

      // verify the required parameter 'preview' is set
      if (preview == undefined || preview == null) {
        throw "Missing the required parameter 'preview' when calling addWidgetMetadata";
      }


      var pathParams = {
        'widgetId': widgetId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'metadata': metadata,
        'icon': icon,
        'placeholder': placeholder,
        'thumbnail': thumbnail,
        'preview': preview
      };

      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = WidgetCreationResponse;

      return this.apiClient.callApi(
        '/v2/widgets/{widgetId}/metadata', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the addWidgetTemplate operation.
     * @callback module:api/VwidgetsApi~addWidgetTemplateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WidgetTemplate} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Save a template to a user&#39;s account.
     * Configuration JSON file should be no larger than 500 KB.
     * @param {String} metadata 
     * @param {File} configuration The Configuration JSON file input
     * @param {module:api/VwidgetsApi~addWidgetTemplateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/WidgetTemplate}
     */
    this.addWidgetTemplate = function(metadata, configuration, callback) {
      var postBody = null;

      // verify the required parameter 'metadata' is set
      if (metadata == undefined || metadata == null) {
        throw "Missing the required parameter 'metadata' when calling addWidgetTemplate";
      }

      // verify the required parameter 'configuration' is set
      if (configuration == undefined || configuration == null) {
        throw "Missing the required parameter 'configuration' when calling addWidgetTemplate";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'metadata': metadata,
        'configuration': configuration
      };

      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = WidgetTemplate;

      return this.apiClient.callApi(
        '/v2/widgets/templates', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the createWidget operation.
     * @callback module:api/VwidgetsApi~createWidgetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WidgetCreationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Register a widget packageName
     * @param {module:model/WidgetRegisterRequest} request 
     * @param {module:api/VwidgetsApi~createWidgetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/WidgetCreationResponse}
     */
    this.createWidget = function(request, callback) {
      var postBody = request;

      // verify the required parameter 'request' is set
      if (request == undefined || request == null) {
        throw "Missing the required parameter 'request' when calling createWidget";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = WidgetCreationResponse;

      return this.apiClient.callApi(
        '/v2/widgets', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteWidget operation.
     * @callback module:api/VwidgetsApi~deleteWidgetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a Widget
     * @param {String} widgetId 
     * @param {module:api/VwidgetsApi~deleteWidgetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.deleteWidget = function(widgetId, callback) {
      var postBody = null;

      // verify the required parameter 'widgetId' is set
      if (widgetId == undefined || widgetId == null) {
        throw "Missing the required parameter 'widgetId' when calling deleteWidget";
      }


      var pathParams = {
        'widgetId': widgetId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/widgets/{widgetId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteWidgetMetadata operation.
     * @callback module:api/VwidgetsApi~deleteWidgetMetadataCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a Widget Metadata
     * @param {String} widgetId 
     * @param {String} metadataId 
     * @param {module:api/VwidgetsApi~deleteWidgetMetadataCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.deleteWidgetMetadata = function(widgetId, metadataId, callback) {
      var postBody = null;

      // verify the required parameter 'widgetId' is set
      if (widgetId == undefined || widgetId == null) {
        throw "Missing the required parameter 'widgetId' when calling deleteWidgetMetadata";
      }

      // verify the required parameter 'metadataId' is set
      if (metadataId == undefined || metadataId == null) {
        throw "Missing the required parameter 'metadataId' when calling deleteWidgetMetadata";
      }


      var pathParams = {
        'widgetId': widgetId,
        'metadataId': metadataId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/widgets/{widgetId}/metadata/{metadataId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteWidgetPackage operation.
     * @callback module:api/VwidgetsApi~deleteWidgetPackageCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a Widget Version Package
     * @param {String} widgetId 
     * @param {String} packageId 
     * @param {module:api/VwidgetsApi~deleteWidgetPackageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.deleteWidgetPackage = function(widgetId, packageId, callback) {
      var postBody = null;

      // verify the required parameter 'widgetId' is set
      if (widgetId == undefined || widgetId == null) {
        throw "Missing the required parameter 'widgetId' when calling deleteWidgetPackage";
      }

      // verify the required parameter 'packageId' is set
      if (packageId == undefined || packageId == null) {
        throw "Missing the required parameter 'packageId' when calling deleteWidgetPackage";
      }


      var pathParams = {
        'widgetId': widgetId,
        'packageId': packageId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/widgets/{widgetId}/package/{packageId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteWidgetTemplate operation.
     * @callback module:api/VwidgetsApi~deleteWidgetTemplateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Soft Delete a Widget from a user&#39;s account, using the template id.
     * @param {String} id 
     * @param {module:api/VwidgetsApi~deleteWidgetTemplateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.deleteWidgetTemplate = function(id, callback) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deleteWidgetTemplate";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/widgets/templates/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getWidget operation.
     * @callback module:api/VwidgetsApi~getWidgetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GetWidgetResp} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieve a Widget info and download the latest package for a given sdk version
     * @param {String} id 
     * @param {String} minSdkVersion 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.addToAccount 
     * @param {module:api/VwidgetsApi~getWidgetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/GetWidgetResp}
     */
    this.getWidget = function(id, minSdkVersion, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getWidget";
      }

      // verify the required parameter 'minSdkVersion' is set
      if (minSdkVersion == undefined || minSdkVersion == null) {
        throw "Missing the required parameter 'minSdkVersion' when calling getWidget";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'minSdkVersion': minSdkVersion,
        'addToAccount': opts['addToAccount']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = GetWidgetResp;

      return this.apiClient.callApi(
        '/v2/widgets/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getWidgetTemplates operation.
     * @callback module:api/VwidgetsApi~getWidgetTemplatesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WidgetTemplateQueryResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the list of templates added to a user&#39;s account.
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.limit 
     * @param {Integer} opts.offset 
     * @param {String} opts.sortBy 
     * @param {String} opts.nextPageToken 
     * @param {String} opts.minSdkVersion 
     * @param {module:api/VwidgetsApi~getWidgetTemplatesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/WidgetTemplateQueryResponse}
     */
    this.getWidgetTemplates = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'limit': opts['limit'],
        'offset': opts['offset'],
        'sortBy': opts['sortBy'],
        'nextPageToken': opts['nextPageToken'],
        'minSdkVersion': opts['minSdkVersion']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WidgetTemplateQueryResponse;

      return this.apiClient.callApi(
        '/v2/widgets/templates', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getWidgetUpdates operation.
     * @callback module:api/VwidgetsApi~getWidgetUpdatesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WidgetGetUpdatesResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the most recent versions the widgets passed in.
     * Max 15.
     * @param {String} minSdkVersion 
     * @param {Array.<String>} ids 
     * @param {Array.<String>} versions 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.limit 
     * @param {Integer} opts.offset 
     * @param {String} opts.sortBy 
     * @param {String} opts.nextPageToken 
     * @param {module:api/VwidgetsApi~getWidgetUpdatesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/WidgetGetUpdatesResponse}
     */
    this.getWidgetUpdates = function(minSdkVersion, ids, versions, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'minSdkVersion' is set
      if (minSdkVersion == undefined || minSdkVersion == null) {
        throw "Missing the required parameter 'minSdkVersion' when calling getWidgetUpdates";
      }

      // verify the required parameter 'ids' is set
      if (ids == undefined || ids == null) {
        throw "Missing the required parameter 'ids' when calling getWidgetUpdates";
      }

      // verify the required parameter 'versions' is set
      if (versions == undefined || versions == null) {
        throw "Missing the required parameter 'versions' when calling getWidgetUpdates";
      }


      var pathParams = {
      };
      var queryParams = {
        'limit': opts['limit'],
        'offset': opts['offset'],
        'sortBy': opts['sortBy'],
        'nextPageToken': opts['nextPageToken'],
        'minSdkVersion': minSdkVersion,
        'ids': this.apiClient.buildCollectionParam(ids, 'csv'),
        'versions': this.apiClient.buildCollectionParam(versions, 'csv')
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WidgetGetUpdatesResponse;

      return this.apiClient.callApi(
        '/v2/widgets/updates', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the queryWidgets operation.
     * @callback module:api/VwidgetsApi~queryWidgetsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Widget>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Query for Widgets.
     * If langPrefer is used, we first try to return metadata with the language specified, then fallback\n to English, and finally should no English metadata exist, the original metadata is returned.
     * @param {String} minSdkVersion 
     * @param {Object} opts Optional parameters
     * @param {String} opts.packageName 
     * @param {module:model/String} opts.language Default to ENGLISH_US
     * @param {module:model/String} opts.country Default to UNITED_STATES
     * @param {String} opts.title 
     * @param {String} opts.author 
     * @param {String} opts.version 
     * @param {Array.<Integer>} opts.grades 
     * @param {Array.<String>} opts.subjects 
     * @param {Array.<String>} opts.capabilities 
     * @param {Array.<String>} opts.tags 
     * @param {Integer} opts.limit 
     * @param {String} opts.sortBy 
     * @param {String} opts.nextPageToken 
     * @param {module:model/String} opts.langPrefer Preferred language to search on
     * @param {module:api/VwidgetsApi~queryWidgetsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {Array.<module:model/Widget>}
     */
    this.queryWidgets = function(minSdkVersion, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'minSdkVersion' is set
      if (minSdkVersion == undefined || minSdkVersion == null) {
        throw "Missing the required parameter 'minSdkVersion' when calling queryWidgets";
      }


      var pathParams = {
      };
      var queryParams = {
        'minSdkVersion': minSdkVersion,
        'packageName': opts['packageName'],
        'language': opts['language'],
        'country': opts['country'],
        'title': opts['title'],
        'author': opts['author'],
        'version': opts['version'],
        'grades': this.apiClient.buildCollectionParam(opts['grades'], 'csv'),
        'subjects': this.apiClient.buildCollectionParam(opts['subjects'], 'csv'),
        'capabilities': this.apiClient.buildCollectionParam(opts['capabilities'], 'csv'),
        'tags': this.apiClient.buildCollectionParam(opts['tags'], 'csv'),
        'limit': opts['limit'],
        'sortBy': opts['sortBy'],
        'nextPageToken': opts['nextPageToken'],
        'langPrefer': opts['langPrefer']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [Widget];

      return this.apiClient.callApi(
        '/v2/widgets', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateWidgetMetadata operation.
     * @callback module:api/VwidgetsApi~updateWidgetMetadataCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update a Widget
     * @param {String} widgetId 
     * @param {String} metadataId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.metadata 
     * @param {File} opts.icon 
     * @param {File} opts.placeholder 
     * @param {File} opts.thumbnail 
     * @param {File} opts.preview 
     * @param {module:api/VwidgetsApi~updateWidgetMetadataCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.updateWidgetMetadata = function(widgetId, metadataId, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'widgetId' is set
      if (widgetId == undefined || widgetId == null) {
        throw "Missing the required parameter 'widgetId' when calling updateWidgetMetadata";
      }

      // verify the required parameter 'metadataId' is set
      if (metadataId == undefined || metadataId == null) {
        throw "Missing the required parameter 'metadataId' when calling updateWidgetMetadata";
      }


      var pathParams = {
        'widgetId': widgetId,
        'metadataId': metadataId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'metadata': opts['metadata'],
        'icon': opts['icon'],
        'placeholder': opts['placeholder'],
        'thumbnail': opts['thumbnail'],
        'preview': opts['preview']
      };

      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/widgets/{widgetId}/metadata/{metadataId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateWidgetPackage operation.
     * @callback module:api/VwidgetsApi~updateWidgetPackageCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update a Widget Package
     * @param {String} widgetId 
     * @param {String} packageId 
     * @param {String} updates 
     * @param {Object} opts Optional parameters
     * @param {File} opts.widget The Widget file input
     * @param {module:api/VwidgetsApi~updateWidgetPackageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.updateWidgetPackage = function(widgetId, packageId, updates, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'widgetId' is set
      if (widgetId == undefined || widgetId == null) {
        throw "Missing the required parameter 'widgetId' when calling updateWidgetPackage";
      }

      // verify the required parameter 'packageId' is set
      if (packageId == undefined || packageId == null) {
        throw "Missing the required parameter 'packageId' when calling updateWidgetPackage";
      }

      // verify the required parameter 'updates' is set
      if (updates == undefined || updates == null) {
        throw "Missing the required parameter 'updates' when calling updateWidgetPackage";
      }


      var pathParams = {
        'widgetId': widgetId,
        'packageId': packageId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'widget': opts['widget'],
        'updates': updates
      };

      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/widgets/{widgetId}/package/{packageId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateWidgetTemplate operation.
     * @callback module:api/VwidgetsApi~updateWidgetTemplateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update a template&#39;s title.
     * @param {String} id 
     * @param {module:model/WidgetTemplateUpdateRequest} widgetUpdateRequest 
     * @param {module:api/VwidgetsApi~updateWidgetTemplateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.updateWidgetTemplate = function(id, widgetUpdateRequest, callback) {
      var postBody = widgetUpdateRequest;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateWidgetTemplate";
      }

      // verify the required parameter 'widgetUpdateRequest' is set
      if (widgetUpdateRequest == undefined || widgetUpdateRequest == null) {
        throw "Missing the required parameter 'widgetUpdateRequest' when calling updateWidgetTemplate";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/widgets/templates/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the uploadWidgetPackage operation.
     * @callback module:api/VwidgetsApi~uploadWidgetPackageCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WidgetCreationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Upload a widget Package
     * @param {String} widgetId 
     * @param {File} widget The Widget file input
     * @param {String} packageMetadata 
     * @param {module:api/VwidgetsApi~uploadWidgetPackageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/WidgetCreationResponse}
     */
    this.uploadWidgetPackage = function(widgetId, widget, packageMetadata, callback) {
      var postBody = null;

      // verify the required parameter 'widgetId' is set
      if (widgetId == undefined || widgetId == null) {
        throw "Missing the required parameter 'widgetId' when calling uploadWidgetPackage";
      }

      // verify the required parameter 'widget' is set
      if (widget == undefined || widget == null) {
        throw "Missing the required parameter 'widget' when calling uploadWidgetPackage";
      }

      // verify the required parameter 'packageMetadata' is set
      if (packageMetadata == undefined || packageMetadata == null) {
        throw "Missing the required parameter 'packageMetadata' when calling uploadWidgetPackage";
      }


      var pathParams = {
        'widgetId': widgetId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'widget': widget,
        'packageMetadata': packageMetadata
      };

      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = WidgetCreationResponse;

      return this.apiClient.callApi(
        '/v2/widgets/{widgetId}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
